import React from "react";
// react component that copies the given text inside your clipboard
// reactstrap components
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  Button,    
} from "reactstrap";
import {
   Link
} from "react-router-dom";
// core components
import {PASSWORD_REGEXP} from '../../settings/shared/constants'
import { toast } from 'react-toastify';
import UserService from '../../services/api/User'
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import Background from 'assets/img/1.jpg';
import Background2 from 'assets/img/2.jpg';
import Background3 from 'assets/img/3.jpg';
import Background4 from 'assets/img/4.jpg';
import Background5 from 'assets/img/5.jpg';
 import Background6 from 'assets/img/bg14.jpg';


const styles = {
    errorBox:{
      textAlign:"center",
      marginBottom:20
    },
    error:{
      color: "rgb(255, 0, 0)",
      fontSize: 13,
      backgroundColor: "rgb(249, 228, 228)",
      padding: "6px 100px 6px 100px",
      borderRadius:6
    },
    passwordHint:{
      color:"gray",
      fontSize:12
    }
  }
  
class UpdatePassword extends React.Component {

  constructor(props) {
    super(props)     
    this.state = { 
    errorSubmitted:false,
    passswordChecker:'poor',
    oldPass:'',
    newPass:'',
    confirmPass:'',
    errorMessage:'',
    images: [
        Background,
        Background2,
        Background3,
        Background4,
        Background5,
        Background6,
      ],
    }
  }

 componentDidMount() {
    document.body.classList.add("login-page");
  
    document.body.style.backgroundImage = `url(${this.state.selectedImage})`;
    var background = this.state.images[Math.floor(Math.random() * this.state.images.length)];
    this.state.selectedImage = background;
   
  document.body.classList.add("bgdefault");
  document.body.style.backgroundImage = `url(${this.state.selectedImage})`;
  document.body.style.backgroundPosition = 'center';
  document.body.style.backgroundSize = 'cover';
  document.body.style.backgroundRepeat = 'no-repeat';
  var spans = document.getElementsByClassName('full-page section-image');
  var i;
  for(i=0; i<spans.length; i++) {
      spans[i].classList.remove("df-bg-white");
  }
  }


  LogoutSession = () =>{
    localStorage.clear();
    sessionStorage.clear();
    this.props.history.push('/auth/login-page');
  }

  setErrorMessage(message){
     if(message==""){
       this.setState({
         errorMessage:message,
         errorSubmitted:false
       })
     }else{
    document.getElementById('errorDiv').scrollIntoView()
     this.setState({
       errorMessage:message,
       errorSubmitted:true
     });
     }
  }

  handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    switch (name) {
      case 'newPass': 
        if(PASSWORD_REGEXP.test(value)){
          this.setState({
            passswordChecker:"strong"
          })
        }
        else if(value.length==0 || value==undefined){
          this.setState({
            passswordChecker:"poor"
          })
        }
        else if(value.length==6){
          this.setState({
            passswordChecker:"weak"
          })
        }
        else if(value.length==7){
          this.setState({
            passswordChecker:"medium"
          })
        }
      default:
        break;
    }
      this.setState({ [name]: value});
  }

  // Submit user Data
  SubmitPasswordChange = (event) => {
    event.preventDefault();
    
      if(this.state.oldPass=="" || this.state.oldPass==undefined){
         this.setErrorMessage("Please Enter Old Password");
      }
      else if(this.state.newPass=="" || this.state.newPass==undefined){
         this.setErrorMessage("Please Enter New Password");
      }
      else if(this.state.newPass.length < 8){
         this.setErrorMessage("Password must be 8 characters long!");
      }
      else if(!PASSWORD_REGEXP.test(this.state.newPass)){
            this.setErrorMessage("Password Policy does not match");
      }
      else if(this.state.oldPass == this.state.newPass==undefined){
          this.setErrorMessage("New password must differ from old password");
      }
      else if(this.state.confirmPass=="" || this.state.confirmPass==undefined){
         this.setErrorMessage("Please Enter Confirm Password");
      }
      else if(this.state.newPass !== this.state.confirmPass){
          this.setErrorMessage("Password mismatch!");
      }
      else{
        this.setErrorMessage("");
         if(!this.state.errorSubmitted) {     
               let post ={
               oldPassword:this.state.oldPass,
               newPassword:this.state.newPass,
             }
             // console.log(JSON.stringify(post));
               //Post update password service integration
               UserService.UpdatePassword(post)
               .then((response) => {
                   if (response.status === 'SUCCESS') {
                   localStorage.clear();
                   toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Password Updated Successfully!</b></i>); 
                   this.props.history.push('/auth/login-page');
                   this.clearformData();   // Reset Form data    
                   } else {
                    toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
                    this.clearformData();   // Reset Form data    
                   }
               });
                 }else{
                   console.error('Invalid Form')
                 }
     } 
  }

  // Reset form data
  clearformData(){
    this.setState({
      oldPass:'',
      newPass:'',
      confirmPass:'',
      passswordChecker:'poor'
    })
  }


  render() {
    const {errors} = this.state;
    const bgdefault = {
        backgroundImage: `url(${this.state.selectedImage} )`, 
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
      }  
    return (
    //   <LoadingOverlay
    //   active={this.state.loading}
    //   spinner={<CircleLoader
    //     size={35}
    //     color={"#123abc"}
    //     loading={this.state.loading}
    //   />}
    // >
      <>
     
     <div className="content">
          <div className="login-page">
            <Container>
         
            <Col xs={12} md={12} lg={10} className="ml-auto mr-auto">
            <div className=" col" id="errorDiv">
              <Card className=" shadow">
                <CardHeader className=" bg-transparent">
                  <Row className="align-items-center">
                    <div className="col">
                    <CardTitle tag="h5">Update Password</CardTitle>
                    </div>
                   <div className="col text-right" onClick={e => this.LogoutSession()}>
                    <span className="close clear-filter">×</span>
                  </div>
                  </Row>
               </CardHeader>
                <CardBody>
                <div className="carcontent">

                    {this.state.errorSubmitted &&
                    <div style={styles.errorBox}>
                    <span style={styles.error}>{this.state.errorMessage}</span>
                    </div>
                    }
                  <Form onSubmit={this.SubmitPasswordChange} noValidate>
                    <div className="pl-lg-4">
                        <Row>
                                <Col lg="6">
                                
                                <FormGroup>
                                        <label
                                        className="form-control-label"
                                        htmlFor="input-email"
                                        >
                                        Old Password
                                        </label>
                                        <Input
                                    className="form-control"
                                    placeholder="Old Password"
                                    name="oldPass"
                                    value={this.state.oldPass}
                                    type="password"
                                    onChange={this.handleChange}/>
                                    </FormGroup>
                                
                                </Col>
                      </Row>
                      <Row>
                                <Col lg="6">
                                
                                <FormGroup>
                                        <label
                                        className="form-control-label"
                                        htmlFor="input-email"
                                        >
                                        New Password
                                        </label>
                                        <Input
                                    className="form-control"
                                    placeholder="New Password"
                                    name="newPass"
                                    value={this.state.newPass}
                                    type="password"
                                    onChange={this.handleChange}/>
                                    <div className="text-muted font-italic">
                                <small>
                                    password strength:{" "}
                                    <span className="text-success font-weight-700">{this.state.passswordChecker}</span>
                                </small>
                                </div>
                                    </FormGroup>
                                </Col>
                      </Row>
                      <Row>
                                <Col lg="6">
                                
                                <FormGroup>
                                        <label
                                        className="form-control-label"
                                        htmlFor="input-email"
                                        >
                                        Confirm Password
                                        </label>
                                        <Input
                                    className="form-control"
                                    placeholder="Confirm Password"
                                    name="confirmPass"
                                    value={this.state.confirmPass}
                                    type="password"
                                    onChange={this.handleChange}/>
                                    </FormGroup>
                <span style={styles.passwordHint}>Use 8 or more characters with a mix of one UpperCase, LowerCase, numbers & symbols</span>
                                </Col>
                      </Row>
                          
                    </div>
                    <hr className="my-4" />
                    <Row>  
                    <Col lg="1">
                    <FormGroup>
                     <Button
                       color="primary"
                       size="sm"
                       type="submit"
                       onClick={e=>this.clearformData()}
                     >
                       Clear
                     </Button>
                     </FormGroup>
                     </Col>
                       <Col lg="1">
                       <FormGroup>
                     <Button
                       color="primary"
                       size="sm"
                     >
                       Submit
                     </Button>
                     </FormGroup>
                     </Col>
                    </Row>
                    </Form>
                </div>
                </CardBody>
              </Card>
            </div>
          </Col>
      
      </Container>
        </div>
        </div>
        <div
          className="full-page-background bgdefault"
        />
      </>
    //   </LoadingOverlay>
    );
  }
}

export default UpdatePassword;
